import { ChartsContainer, StatsContainer, DynamicChart } from "../components";
import { customFetch } from "../utils/custom-fetch.js";
import { useLoaderData } from "react-router-dom";

export const loader = async () => {
  try {
    const response = await customFetch.get("buildings/stats");
    return response.data;
  } catch (error) {
    return error;
  }
};

const Stats = () => {
  const { defaultStats, monthlyApplications } = useLoaderData();

  return (
    <>
      <StatsContainer defaultStats={defaultStats} />
      {monthlyApplications.length > 1 && (
        <ChartsContainer data={monthlyApplications} />
      )}
      <DynamicChart data={defaultStats.cityStats} title="חלוקה לפי ערים" />
      <DynamicChart data={defaultStats.workOnSaturday} title="פעילות בשבת" />
    </>
  );
};

export default Stats;
